/* @jsx h */
import { defineComponent, h } from "vue";
import type { AdminRestaurantBreakdownDatum } from "@lemmonhq/types";
import { formatDelta } from "./AdminMetricCard";

import { formatAdminPrice } from "../helpers";

export const AdminRestaurantRevenueTable = defineComponent({
  name: "AdminRestaurantRevenueTable",
  props: ["rows"],
  setup(props) {
    return () => {
      const rows = (props.rows || []) as AdminRestaurantBreakdownDatum[];

      return (
        <div class="rounded-2xl border border-base-300/60 bg-base-100 shadow-sm">
          <div class="border-b border-base-300/60 px-5 py-4">
            <h3 class="text-lg font-semibold text-accent">Restaurants</h3>
            <p class="text-sm text-base-content/60">
              Revenue and operational totals for the selected period.
            </p>
          </div>

          {rows.length === 0 ? (
            <div class="px-5 py-12 text-center text-sm text-base-content/60">
              No restaurants matched the current filters.
            </div>
          ) : (
            <div class="overflow-x-auto">
              <table class="table">
                <thead>
                  <tr>
                    <th>Restaurant</th>
                    <th class="text-right">GMV</th>
                    <th class="text-right">Delta</th>
                    <th class="text-right">Payments</th>
                    <th class="text-right">Reservations</th>
                    <th class="text-right">Tips</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => {
                    const delta = formatDelta(
                      row.gmv_current,
                      row.gmv_previous,
                    );
                    return (
                      <tr key={row.restaurant_id}>
                        <td>
                          <div class="font-medium text-accent">
                            {row.restaurant_name}
                          </div>
                          {row.restaurant_slug ? (
                            <div class="text-xs text-base-content/50">
                              {row.restaurant_slug}
                            </div>
                          ) : null}
                        </td>
                        <td class="text-right font-medium text-accent">
                          {formatAdminPrice(row.gmv_current, false, 2)}
                        </td>
                        <td
                          class={`text-right ${
                            delta.positive ? "text-success" : "text-error"
                          }`}
                        >
                          {delta.positive ? "+" : "-"}
                          {delta.value.toFixed(1)}%
                        </td>
                        <td class="text-right">{row.payments_count_current}</td>
                        <td class="text-right">
                          {row.reservations_count_current}
                        </td>
                        <td class="text-right">
                          {formatAdminPrice(row.tips_current, false, 2)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    };
  },
});
